import { stripUnit } from 'polished';

export const pxSum = (a: string, ...args: any[]) =>
  `${args.reduce((acc, b) => acc + stripUnit(b), stripUnit(a))}px`;
